import { render, staticRenderFns } from "./MaterialDonationList.vue?vue&type=template&id=6b049014&"
import script from "./MaterialDonationList.vue?vue&type=script&lang=js&"
export * from "./MaterialDonationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports